import { render, staticRenderFns } from "./ChangeSamplingInformation.vue?vue&type=template&id=18273ac5&"
import script from "./ChangeSamplingInformation.vue?vue&type=script&lang=js&"
export * from "./ChangeSamplingInformation.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSamplingInformation.vue?vue&type=style&index=0&id=18273ac5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports